import React, { useEffect, useState } from 'react';
import './BuyerProfile.scss';
import { PublicProfile } from './PublicProfile/PublicProfile';
import { useStateSelector } from '../../../../store/selectors';
import { useDispatch } from 'react-redux';
import { GetBuyer } from '../../../../slices/marketplace/buyer/thunks/get-buyer.thunk';
import { PrivateProfile } from './PrivateProfile/PrivateProfile';
import { LegalDocumentInputs } from './LegalDocumentInputs/LegalDocumentInputs';
import { LegalIssuesTab } from './LegalIssuesTab/LegalIssuesTab';
import { AdditionalNdaCovenantsTab } from './AdditionalNdaCovenantsTab/AdditionalNdaCovenantsTab';
import { ProfilePreview } from './ProfilePreview/ProfilePreview';
import { TeamMemberPermissions, TeamMemberPermissionsHelper } from '../MyTeamMembers/TeamMemberPermissionsHelper';
import { InternalTeamMemberRole, TeamMemberType } from '../MyTeamMembers/Models/Enums';
import { useFeatureFlag } from '../../../../custom-hooks/useFeatureFlag';
import { FeatureFlagsEnum } from '../../../FeatureFlags/FeatureFlags.enum';

const BuyerProfile = () => {
    const [activeTab, setActiveTab] = useState(0);
    const [isEditMode, setIsEditMode] = useState(false);
    const isFF_MrktplcBuyers_3_13Enabled = useFeatureFlag(
        FeatureFlagsEnum.FF_MrktplcBuyers_3_13
    );

    const [tabData] = useState([
        'Public Profile',
        'Private Documents',
        'Legal Documents Inputs',
        'Legal Issues Guidance',
        'Additional NDA Covenants',
    ]);
    function renderTabContent() {
        const activeTabData = tabComponents.find((tab) => tab.id === activeTab);
        return (
            activeTabData?.content || (
                <div className="d-flex align-items-center justify-content-center mt-4">
                    <h1>Empty Tab</h1>
                </div>
            )
        );
    }
    useEffect(() => {
        fetchBuyerProfile();
    }, []);

    const dispatch = useDispatch() as any;
    const buyerProfile = useStateSelector(
        (state) => state.buyersState.targetBuyer
    );

    const tabComponents = [
        {
            id: 0,
            content: (
                <PublicProfile setIsEditMode={setIsEditMode}></PublicProfile>
            ),
        },
        {
            id: 1,
            content: (
                <PrivateProfile setIsEditMode={setIsEditMode}></PrivateProfile>
            ),
        },
        {
            id: 2,
            content: (
                <LegalDocumentInputs
                    setIsEditMode={setIsEditMode}></LegalDocumentInputs>
            ),
        },
        {
            id: 3,
            content: <LegalIssuesTab setIsEditMode={setIsEditMode} />,
        },
        {
            id: 4,
            content: <AdditionalNdaCovenantsTab setIsEditMode={setIsEditMode} />,
        },
    ];

    const fetchBuyerProfile = async () => {
        await dispatch(GetBuyer({ buyerId: null, includeLoiForm: true }));
    };

    const renderTabs = () => {
        return (
            <div className="buyer-profile practice-page-tabs m-0">
                <div className="RRT__container">
                    <div className="RRT__tabs body-tabs">
                        {tabData?.filter(
                                    (t) =>
                                        (isFF_MrktplcBuyers_3_13Enabled ||
                                            (t !== 'Legal Issues Guidance' && t !== 'Additional NDA Covenants'))
                                )?.map((item, index) => {
                            return (
                                <div
                                    key={index}
                                    className={
                                        activeTab === index
                                            ? 'RRT__tab RRT__tab--first RRT__tab--selected'
                                            : 'RRT__tab'
                                    }
                                    onClick={() => {
                                        setActiveTab(index);
                                    }}>
                                    {item}
                                </div>
                            );
                        })}
                    </div>
                </div>
                {renderTabContent()}
            </div>
        );
    };

    const canEditProfile = () => {
        const requiredPermissions = {
            isPrimaryBuyer: false,
            type: TeamMemberType.Internal,
            role: InternalTeamMemberRole.CorpDev,
            permission: null,
        } as TeamMemberPermissions;
        const currentPermissions = {
            isPrimaryBuyer: buyerProfile.teamMemberRole.isPrimaryBuyer,
            type: buyerProfile.teamMemberRole.teamMemberType,
            role: buyerProfile.teamMemberRole.internalTeamMemberRole,
            permission: null,
        } as TeamMemberPermissions;
        return TeamMemberPermissionsHelper.isAvailable(
            currentPermissions,
            requiredPermissions
        );
    };

    const renderPreview = () => {
        return (
            <ProfilePreview
                isReadonly={!canEditProfile()}
                setIsEditMode={setIsEditMode}
                showLoiFormsInProfile={true}
            />
        );
    };

    return (
        buyerProfile &&
        (isEditMode && canEditProfile() ? renderTabs() : renderPreview())
    );
};

export default BuyerProfile;
